import request from '../utils/request'

export function getPcBalance() {
  return request({
    url: '/system/member/pc/balance',
    method: 'get'
  })
}
